/** Four to eight digits, matching what the API's validation pipe accepts. */
export const ACCESS_CODE_PATTERN = /^\d{4,8}$/;

export const ACCESS_CODE_MAX_LENGTH = 8;

/**
 * A leading zero is part of the code, so this works on the string as typed — never on a number.
 * `'0421'` and `'421'` are different codes, and parsing either would lose that.
 */
export const accessCodeValidator = (accessCode: string) =>
  ACCESS_CODE_PATTERN.test(accessCode) || 'The access code must be 4 to 8 digits.';
